export const BRAND_COLOR = {
  primary: "primary",
  white: "white",
  black: "black",
  grey: "grey",
  green: "green",
  blue: "blue",
} as const;
